import { useState } from "react";
import usePut from "../usePut";
import toast from "react-hot-toast";

const useUpdateCompanyCompletionStatus = () => {
  const [confirmModalData, setConfirmModalData] = useState({
    isOpen: false,
    card: null,
    status: true,
  });

  const closeConfirmationModal = () => {
    setConfirmModalData((prev) => ({ ...prev, isOpen: false }));
    setTimeout(() => {
      setConfirmModalData({ isOpen: false, card: null, status: true });
    }, 300);
  };

  const { handleAuth, isLoading } = usePut({
    url: "dashboard/update_company_completion_status",
    refreshUrl: ["dashboard/company_completion_status", "is_permission_for_product"],
    onSuccess: (res) => {
      toast.success(res?.data?.message || "Onboarding status updated successfully");
      closeConfirmationModal();
    },
    onError: (err) => {
      const errorMsg = err?.response?.data?.message || "Failed to update onboarding status";
      toast.error(errorMsg);
    },
  });

  const promptComplete = (card) => {
    setConfirmModalData({
      isOpen: true,
      card,
      status: true,
    });
  };

  const promptIncomplete = (card) => {
    setConfirmModalData({
      isOpen: true,
      card,
      status: false,
    });
  };

  const confirmStatusChange = () => {
    if (!confirmModalData.card) return;
    handleAuth.mutate({
      slug: confirmModalData.card.slug,
      status: confirmModalData.status,
    });
  };

  return {
    confirmModalData,
    promptComplete,
    promptIncomplete,
    confirmStatusChange,
    closeConfirmationModal,
    isLoading,
  };
};

export default useUpdateCompanyCompletionStatus;
